import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_sidebar/grower')({
  component: GrowerLayout,
})

function GrowerLayout() {
  return <Outlet />
}

